import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import classNames from 'classnames';

import IMAGES from 'modules/assets/web';

const OnboardingHeader = props => {
  const { currentGroup, groups } = props;

  const renderBgImage = () => {
    if (currentGroup !== 1) {
      return (
        <img
          alt="header-background"
          className="bg-image d-none d-md-block"
          src={IMAGES[`ONBOARDING_HEADER_BACKGROUND${currentGroup}`]}
        />
      );
    }
    return null;
  };

  const renderPrefaceHeaderBg = () => (
    <div className="header--background position-absolute w-100 h-100">
      <div className="d-flex justify-content-between">
        <img
          alt="header-background"
          className={classNames('bg-image d-none d-md-block', {
            'bg-image-center': currentGroup !== 1,
          })}
          src={IMAGES[`ONBOARDING_HEADER_BACKGROUND${currentGroup}`]}
        />
        {/* <img
          alt="coach"
          className="coach position-absolute"
          src={IMAGES.ONBOARDING_COACH}
        /> */}
      </div>
    </div>
  );

  const renderMobileBg = () => (
    <div className="d-md-none mobile-other-header-bg">
      <img
        alt="group background"
        className="mobile-group-header-background position-absolute"
        src={IMAGES.ONBOARDING_HEADER_BACKGROUND_MOBILE}
      />
      <img
        alt="group icon"
        className="group-icon"
        src={IMAGES[`ONBOARDING_HEADER_BACKGROUND_MOBILE${currentGroup}`]}
      />
    </div>
  );

  return (
    <div className="page--header preface">
      {renderBgImage()}
      <div
        className={`header--content position-relative${
          currentGroup === 1
            ? ' preface'
            : ' d-flex align-items-center justify-content-between'
        }`}
      >
        {currentGroup === 1 && renderPrefaceHeaderBg()}
        <h1 className="main">{groups[currentGroup - 1].header}</h1>
        <div className="preface-header-content position-relative">
          <div>
            {/* <div className="sub">
              {ReactHtmlParser(groups[currentGroup - 1].intro)}
            </div> */}
          </div>
        </div>
        {renderMobileBg()}
        <img
          alt="onboarding-round"
          className="d-none d-md-block onboarding-round-image absolute-bottom-center"
          src={IMAGES[`ONBOARDING_ROUND${currentGroup}`]}
        />
      </div>
    </div>
  );
};

OnboardingHeader.propTypes = {
  currentGroup: PropTypes.number.isRequired,
  groups: PropTypes.array.isRequired,
};

export default OnboardingHeader;
